import {AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {Chart, ChartConfiguration, ChartType} from "chart.js/auto";

@Component({
  selector: 'ms-pie-chart-widget',
  imports: [],
  templateUrl: './pie-chart-widget.component.html',
  styleUrl: './pie-chart-widget.component.scss'
})
export class PieChartWidgetComponent implements AfterViewInit, OnChanges {

  @ViewChild('chartCanvas') chartCanvas!: ElementRef<HTMLCanvasElement>;
  @Input() title = 'Répartition';
  @Input() labels: string[] = ['Cluster 1', 'Cluster 2', 'Autres'];
  @Input() data: number[] = [1147, 1189, 0];
  @Input() colors: string[] = ['#10b981', '#22c55e', '#0ea5e9'];
  @Input() type: ChartType = 'pie'; // ou 'doughnut'

  public chart?: Chart;

  constructor() {
  }

  ngAfterViewInit() {
    this.createChart();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.chart && (changes['data'] || changes['labels'])) {
      this.updateChart();
    }
  }

  private createChart() {
    const ctx = this.chartCanvas.nativeElement.getContext('2d');
    if (!ctx) return;

    this.chart = new Chart(ctx, {
      type: this.type,
      data: {
        labels: this.labels,
        datasets: [
          {
            data: this.data,
            backgroundColor: this.colors.map(c => this.withAlpha(c, 0.25)),
            borderColor: this.colors,
            borderWidth: 2,
            hoverOffset: 6
          }
        ]
      },
      options: this.chartOptions
    });
  }

  private updateChart() {
    if (!this.chart) return;
    this.chart.data.labels = this.labels;
    this.chart.data.datasets[0].data = this.data;
    (this.chart.data.datasets[0] as any).borderColor = this.colors;
    (this.chart.data.datasets[0] as any).backgroundColor = this.colors.map(c => this.withAlpha(c, 0.25));
    this.chart.update();
  }

  private get chartOptions(): ChartConfiguration['options'] {
    return {
      responsive: true,
      maintainAspectRatio: false,
      // @ts-ignore
      cutout: this.type === 'doughnut' ? '65%' : undefined,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            color: '#334155',
            usePointStyle: true,
            pointStyle: 'circle',
            boxWidth: 8
          }
        },
        tooltip: {
          callbacks: {
            label: (ctx) => {
              const total = (ctx.dataset.data as number[]).reduce((a, b) => a + b, 0);
              const v = ctx.parsed as number;
              const pct = total ? Math.round((v / total) * 100) : 0;
              return ` ${ctx.label}: ${v} (${pct}%)`;
            }
          }
        }
      }
    };
  }

  private withAlpha(color: string, alpha: number) {
    // accepte #rrggbb ou #rgb
    const hex = color.replace('#', '');
    const bigint = parseInt(hex.length === 3
      ? hex.split('').map(c => c + c).join('')
      : hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
}
